import React from 'react';
import './AirInLabelSelect.css';
import { Select } from 'antd';

const AirInLabelSelect = ({label, children, ...props}) =>
  <div className="AirInLabelSelect">
    <div className="prefix">{label}</div>
    <Select size="large" style={{ width: '100%' }} {...props}>
      {children}
    </Select>
  </div>

export default AirInLabelSelect;



// WEBPACK FOOTER //
// ./src/common/components/AirInLabelSelect/AirInLabelSelect.js